import React from 'react';
import { render } from 'react-dom';
import 'semantic-ui-css/semantic.min.css';

import Cookies from 'universal-cookie';
import registerServiceWorker from './registerServiceWorker';
import route from './app/Router';
import Login from './app/Login';

const cookies = new Cookies();

if ( cookies.get('tokenKYCSafecash') ){
  render(route, document.getElementById('root'));
} else {
  render(<Login />, document.getElementById('root'));
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js